import { isString } from 'lodash'
import { sniff } from '@/util'
import queryString from 'query-string'

const openWebview = function (config = '') {
  let resultStr = ''
  let urlJson = {}
  if (isString(config)) {
    resultStr = config
  } else {
    /* eslint-disable-next-line */
    const { url = '', theme, fullscreen, immersed, ...otherConfig } = config
    const parsedUrl = queryString.parseUrl(String(config.url))
    // 拆解出path和参数
    const sourceQuery = parsedUrl.query
    const sourceUrl = parsedUrl.url
    // 合并拆解出的path和参数出一个新的url
    const assignQuery = { ...sourceQuery, theme, isfullscreen: fullscreen, immersed, 'h5-version': window.ARES_VERSION, pageViewCallback : true, ...otherConfig  }
    urlJson = {
      url: queryString.stringifyUrl({
        url: sourceUrl,
        query: assignQuery,
      }),
      theme,
      fullscreen,
      immersed,
    }
    if ( sniff.isAndroid ) {
      urlJson.pageviewcallback = true
    } else {
      urlJson.pageViewCallback = true
    }
    try {
      resultStr = JSON.stringify(urlJson)
    } catch (error) {
      resultStr = ''
    }
  }

  if (sniff.isUboxAndroidApp) {
    window.app?.openWebview && window.app?.openWebview(resultStr)
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.openWebview && window?.webkit?.messageHandlers?.openWebview.postMessage(resultStr)
  } else if( sniff.isWechatMiniProgram ){
    window.wx.miniProgram.navigateTo({
      url: `/pages/web-view-custom/web-view-custom?url=${encodeURIComponent(urlJson?.url)}` ,
    })
  }
}

export default openWebview